import React from "react";
import VersionedLegalDocument from "./VersionedLegalDocument";

export default function PrivacyPolicy() {
  return <VersionedLegalDocument documentType={["ru_privacy", "privacy"]} />;
}
